// Pure rest-timer math. The UI computes from an absolute end timestamp (never a
// decrement counter) so backgrounding/locking the phone can't drift it.

export function remainingMs(endTs, now) {
  return Math.max(0, endTs - now);
}

export function isOvertime(endTs, now) {
  return now > endTs;
}

export function formatClock(ms) {
  const total = Math.max(0, Math.round(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
